import './scss/index.scss'

import DialogComponent from './DialogComponent'

const DialogPackage = {
    name: 'dialog',
    configure: function(config) {
        config.addComponent('dialog', DialogComponent)

        config.addLabel('ok', {
            en: 'Ok',
            sv: 'Ok'
        })
    }
}

export {DialogPackage}
